import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('hard-delete', {
  template: require('./template.html'),
  name: 'disable-enable',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentUser', 'account']),
    confirmed() {
      return this.currentUser.email === this.confirmemail;
    },
  },
  components: {
    dropsLoader,
  },
  data() {
    return {
      loading: false,
      saveError: false,
      confirmemail: '',
    };
  },
  props: ['toggle-modal', 'modal'],
  methods: {
    async hardDeleteUser() {
      if (!this.confirmed) {
        this.saveError = 'You must confirm user email.';
        return;
      }
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          this.saveError = false;
          try {
            await this.$lightning([{ name: 'hardDeleteAccount' }]);
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: 'success',
              message: `Successfully deleted user: ${this.currentUser.email}!`,
            });
            this.closeModal('hardDelete');
            setTimeout(() => {
              this.$router.push({ path: '/storm-drzzle-accounts' });
            }, 500);
          } catch (e) {
            const message = e.message || e;
            this.saveError = message;
            this.$log.error(message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/profile/hard-delete/index.js